/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/30
 * @Version : 1.0
 * @Content : 通用接口
 */
import BaseApi from './api'

const fetch = new BaseApi(process.env.VUE_APP_BASEURL)

export default fetch
